import AppConfig from "@/config/appConfig";

export class Logs {

  public static forceActive = false; // Force all logs to show
  public static active = false; // Is overwrite based on the env

  public static update() {
    Logs.active = AppConfig.IS_DEBUG;
  }

  private service: string;
  private active: boolean;

  constructor(service: string, active = false) {
    this.service = service;
    this.active = active;
  }

  public debug(messages: any): void {
    if (this.isLogActive()) {
      console.group(`%c💬 ${this.service} %c`, "font-weight:800; color: #0394fc;", "font-weight: normal");
      if (Array.isArray(messages)) {
        messages.forEach(message => console.log(message));
      } else {
        console.log(messages);
      }
      console.groupEnd();
    }
  }

  public isLogActive(): boolean {
    return Logs.active && (this.active || Logs.forceActive);
  }

}

export const viewLog = new Logs('View', true);
